import React from "react";
import styled from "styled-components";
import { TitleText } from "../../../ui/Text";
import { PositiveChangeIcon } from "../../../assets/svg/PositiveChangeIcon";
import numeral from "numeral";
import moment from "moment";
import NegativeChageIcon from "../../../assets/svg/NegativeChageIcon";
import { get } from "../../../utils/get";

interface DataViewProps {
  data?: any[];
  getColor?: any;
}

const Measures = ({ data, getColor }: DataViewProps) => {
  const kpi_targets =
    data &&
    data.sort((a: any, b: any) => {
      if (a.label.includes("Q")) {
        return ("" + a.label).localeCompare(b.label);
      } else {
        return (
          parseInt(moment().month(a.label).format("M")) -
          parseInt(moment().month(b.label).format("M"))
        );
      }
    });

  return (
    <Container id="measure-container">
      <MeasuresHeader length={data && data.length}>
        <div />
        {kpi_targets &&
          kpi_targets.map((target) => <TitleText>{target.label}</TitleText>)}
      </MeasuresHeader>
      <MeasuresData>
        <div>
          <TitleText style={{ fontSize: 14, color: "#214160", opacity: 0.4 }}>
            Score
          </TitleText>
          <TitleText style={{ fontSize: 14, color: "#214160", opacity: 0.4 }}>
            Target
          </TitleText>
          <TitleText style={{ fontSize: 14, color: "#214160", opacity: 0.4 }}>
            Actual
          </TitleText>
        </div>
        <MeasuresItems length={data && data.length}>
          {kpi_targets &&
            kpi_targets.map((score) => (
              <span>
                <TitleText
                  style={{
                    fontSize: 14,
                    color: getColor(score.score),
                    fontWeight: 600,
                  }}
                >
                  {get(score, "score", 0)}
                </TitleText>
                {score.score > 3 ? (
                  <PositiveChangeIcon
                    style={{ width: "1em", height: "0.3em" }}
                  />
                ) : (
                  <NegativeChageIcon />
                )}
              </span>
            ))}
          {kpi_targets &&
            kpi_targets.map((target) => (
              <>
                <TitleText
                  style={{
                    fontSize: 14,
                    color: "#214160",
                    opacity: 0.4,
                    fontWeight: 600,
                  }}
                >
                  {numeral(target.target).format("0,0.00")}
                </TitleText>
              </>
            ))}
          {kpi_targets &&
            kpi_targets.map((target) => (
              <>
                <TitleText
                  style={{
                    fontSize: 14,
                    color: getColor(target.score),
                  }}
                >
                  {numeral(target.actual_value).format("0,0.00")}
                </TitleText>
              </>
            ))}
        </MeasuresItems>
      </MeasuresData>
    </Container>
  );
};

export default Measures;

const Container = styled.div`
  display: grid;
  grid-template-rows: 3em auto;
  background-color: #f5f6fb;
  border-radius: 1em;

  overflow: auto;
`;

const MeasuresHeader = styled.div<{ length: any }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.length ? `6em repeat(${props.length}, 7rem)` : ""};
  align-items: center;
  justify-items: center;
`;

const MeasuresData = styled.div`
  display: grid;
  grid-template-columns: 6em auto;
  /* grid-template-rows: 1fr 1fr 1fr; */
`;

const MeasuresItems = styled.div<{ length: any }>`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: ${(props) =>
    props.length ? `repeat(${props.length}, 7rem)` : ""};
  justify-items: center;
  span {
    display: flex;
    ${TitleText} {
      padding-right: 0.3em;
    }
  }
`;
